module.exports = __webpack_public_path__ + "play-pause.svg?21dfa3149b274acb9c1819d342a6a169";


//////////////////
// WEBPACK FOOTER
// ./node_modules/blueimp-gallery/img/play-pause.svg
// module id = 37
// module chunks = 0